import mobileOSRegular from './mobileOSRegular';

const { navigator } = window;
const isIpadOS = navigator?.maxTouchPoints > 2 && /MacIntel/.test(navigator?.platform);
const isMobileOS = mobileOSRegular.test(navigator?.userAgent) || isIpadOS;

export default isMobileOS;
